import { useState } from 'react';
import { ChevronDown, ChevronUp } from '@carbon/icons-react';
import classNames from 'classnames';

export function RevealingLink({ text, expandedText, linkColor, reveals, className }) {
  const [showContent, setShowContent] = useState(false);

  return (
    <div className={className}>
      <a
        onClick={() => setShowContent((v) => !v)}
        className={classNames('flex items-center gap-1 underline hover:underline', {
          'text-red-600 hover:text-red-600': linkColor === 'error',
        })}
      >
        {showContent ? expandedText || text : text} {showContent ? <ChevronUp /> : <ChevronDown />}
      </a>

      {showContent && <div className="mt-4">{reveals}</div>}
    </div>
  );
}
